export const CURRENT_REGULATIONS_VERSION = '1.1';
